import React,{useState,useEffect,useContext} from 'react';
import {useHistory} from "react-router-dom";
import {Button,TextField,Snackbar,Typography} from '@material-ui/core';
import UserContext from "../Context/AppContext";
import MuiAlert from '@material-ui/lab/Alert';
import styled from "styled-components";
import { auth } from '../Utils/api';

const LoginContainer=styled.div`
display:block;
`;


const Input=({label,type="",value,changeValue,submit})=>
{
  return <TextField variant="outlined" label={label} style={{margin:"10px 0"}} type={type} value={value} onChange={e => changeValue(e.target.value)} onKeyDown={e =>
    {
      if(e.key==="Enter")
      {
        submit();
      }
    }}/>
}

function Alert({close,Mensaje}) 
{
  return <Snackbar open={Mensaje} autoHideDuration={6000} onClose={close}>
    <MuiAlert onClose={close} severity="error" variant="filled">{Mensaje}</MuiAlert>
  </Snackbar>
}

const Footer=()=>
{
  return  <Typography style={{position:"absolute",bottom:10,right:0,left:0}} variant="body2" color="textSecondary" align="center">
  {'Copyright © '}  
  BertOS 
  {` ${new Date().getFullYear()}`}
  {'.'}
</Typography>
}

const traductorErrores=texto=>
{
  if(texto==="The user account has been disabled by an administrator.")
  {
    return "El usuario ha sido desactivado por un administrador";
  }
  if(texto==="There is no user record corresponding to this identifier. The user may have been deleted.")
  {
    return "El usuario no existe";
  }
  if(texto==="The password is invalid or the user does not have a password.")
  {
    return "La contraseña no es valida"
  }
  if(texto==="Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.")
  {
    return "El acceso a esta cuenta se ha inhabilitado temporalmente debido a muchos intentos fallidos de inicio de sesión. Puede restaurarlo inmediatamente restableciendo su contraseña o puede volver a intentarlo más tarde."
  }
  return texto;
}

const Login=()=>
{
  const History=useHistory();
  const {setLogged}=useContext(UserContext);

  const [User, setUserUI] = useState("");
  const [Password, setPassword] = useState("");
  const [OpenError, setOpenError] = useState(false);

  const closeError=() => setOpenError(false)

  const handleLogin=async ()=>
  {
    const Email=`${User}@gmail.com`

    try
    {
      await auth.signInWithEmailAndPassword(Email,Password);

      const To = localStorage.getItem("pathToLogin") || "/admin";
      localStorage.removeItem("pathToLogin");
      History.push(To);
    }
    catch(error)
    { 
      const Mensaje=traductorErrores(error.message);
      setOpenError(Mensaje);
    }
  }

  useEffect(() =>
  {
    if(auth.currentUser)
    {
      History.push("/admin")
    }
    window.document.title="Lista de Espera";
    window.document.getElementById("favicon").href="https://i.pinimg.com/originals/b5/cb/ac/b5cbac8fd0f87d2d08b490bdd82b597d.png";
  }, [])


  return <>
  <div style={{
    position: 'absolute', 
    left: '50%', 
    top: '50%',
    transform: 'translate(-50%, -50%)'
}}>
    <div>
      <div><Input label="Usuario" value={User} changeValue={setUserUI} submit={handleLogin}/></div>
      <div><Input label="Contraseña" type="password" value={Password} changeValue={setPassword}  submit={handleLogin}/></div>
      <div><Button  variant="contained" color="primary" onClick={handleLogin}>Iniciar sesión</Button></div>
      <p style={{margin:"10px",fontSize:"10px"}}>Versión 5.3.8</p>
    </div>
    
  </div>
  <Alert Mensaje={OpenError} close={() => setOpenError(false)}/>
  </>

  
}


export default Login